import { z } from "zod"
import { useUser } from "@/api/users"
import { Customer, createEmptyCustomer, useCustomer } from "@/api/customers"
import { invoiceSchema } from "./invoice.schema"
import { PDFPreview, InvoiceDocument } from "@braidpay/shared"
import AutoScale from "@/components/ux/auto-scale"

interface PreviewPdfProps {
  invoice: z.input<typeof invoiceSchema>;
}

const emptyCustomer: Customer = createEmptyCustomer()

export default function PreviewPdf({ invoice }: PreviewPdfProps) {
  const { user } = useUser()
  const { customer } = useCustomer(invoice.customerId)

  if (!user) return null

  return (
    <AutoScale
      deviceHeight={900}
      deviceWidth={760}
      contentClassName="p-8 flex"
      frameClassName="border md:border-0"
    >
      <PDFPreview>
        <InvoiceDocument
          invoice={{
            ...invoice,
            total: invoice.items.reduce(
              (acc, item) =>
                acc + Number(item.unitValue) * Number(item.quantity),
              0,
            ),
            number: 1,
            items: invoice.items.map((item) => ({
              description: item.description,
              quantity: Number(item.quantity),
              unitValue: Number(item.unitValue),
            })),
          }}
          user={user}
          customer={customer || emptyCustomer}
        />
      </PDFPreview>
    </AutoScale>
  )
}
